import { Component } from '@angular/core';

import { DbService } from '../../db.service';
import { SpinnerService } from '../../spinner.service';

import { Noticia } from './_noticias.class';

@Component({
    selector: 'app-home-noticias',
    templateUrl: './_noticias.component.html',
    styleUrls: ['./_noticias.component.css']
})

export class Home_NoticiasComponent {
    lista_noticias: Noticia[] = [];

    constructor(
        private dbService: DbService,
        private spinnerService: SpinnerService
    ) {
        // Carrega lateral
        this.noticiasLoad();
    }

    noticiasLoad() {
        this.dbService.get<Noticia[]>('Noticia/GetUltimos3').subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            this.lista_noticias = result;
        });
    }
}
